document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  const variantsScript = form.querySelector('[data-variants-json]');
  if (!variantsScript) return;

  const variants = JSON.parse(variantsScript.textContent || '[]');
  const sellingPlanInput = form.querySelector('[data-selling-plan-input]');

  const oneTimeRadio = form.querySelector('[data-purchase-option="onetime"]');
  const oneTimeCard = form.querySelector('[data-purchase-option-card="onetime"]');
  const subscriptionCard = form.querySelector('[data-subscription-card]');
  const subscriptionOption = form.querySelector('[data-purchase-option="subscription"]');
  const subscriptionRadio = form.querySelector('[data-subscription-radio]');
  const subscriptionRadioIcon = form.querySelector('[data-subscription-radio-icon]');

  const mainPriceEl = form.querySelector('[data-main-price]');
  const onetimePriceEl = form.querySelector('[data-onetime-price]');

  const subscriptionPriceEl = form.querySelector('[data-subscription-price]');
  const subscriptionCompareEl = form.querySelector('[data-subscription-compare]');
  const subscriptionBadgeEl = form.querySelector('[data-subscription-badge]');
  const subscriptionSavingsEl = form.querySelector('[data-subscription-savings]');
  const subscriptionPercentEl = form.querySelector('[data-subscription-percent]');

  const summarySubscriptionWrap = form.querySelector('[data-subscribe-summary]');
  const summarySubscriptionPrice = form.querySelector('[data-subscription-summary-price]');
  const summarySubscriptionPercent = form.querySelector('[data-subscription-summary-percent]');

  const planButtons = form.querySelectorAll('[data-selling-plan-id]');
  const frequencySelect = form.querySelector('[data-frequency-select]');
  const moneyFormat = window.theme?.moneyFormat || window.Shopify?.money_format || '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function getCurrentVariant() {
    const idInput = form.querySelector('input[name="id"], select[name="id"]');
    if (!idInput) return variants[0] || null;
    return variants.find(v => String(v.id) === String(idInput.value)) || variants[0] || null;
  }

  function getSelectedPlanId() {
    return sellingPlanInput?.value ? String(sellingPlanInput.value) : null;
  }

  function getSelectedPlanButton() {
    return form.querySelector('[data-selling-plan-id].hf-flavor-selected');
  }

  // Active selling plan id — from the frequency dropdown when present,
  // otherwise from the legacy plan buttons.
  function getActivePlanId() {
    if (frequencySelect) return frequencySelect.value || null;
    const btn = getSelectedPlanButton();
    return btn ? btn.getAttribute('data-selling-plan-id') : null;
  }

  function getActivePlanPercent() {
    if (frequencySelect) {
      const opt = frequencySelect.options[frequencySelect.selectedIndex];
      return opt ? (opt.getAttribute('data-plan-discount-percent') || '') : '';
    }
    const btn = getSelectedPlanButton();
    return btn ? (btn.getAttribute('data-plan-discount-percent') || '') : '';
  }

  function syncSubscribePercentLabel() {
    const pct = getActivePlanPercent();
    const text = pct ? `${pct}%` : '';
    if (subscriptionPercentEl) subscriptionPercentEl.textContent = text;
    if (summarySubscriptionPercent) summarySubscriptionPercent.textContent = text;
  }

  function getAllocationForVariant(variant, planId) {
    if (!variant || !planId || !variant.selling_plan_allocations) return null;

    return variant.selling_plan_allocations.find((alloc) => {
      const allocPlanId = String(alloc.selling_plan_id || alloc.selling_plan?.id || '');
      return allocPlanId === String(planId);
    }) || null;
  }

  function setSubscriptionSelectedState(isSelected) {
    if (oneTimeCard) {
      oneTimeCard.classList.toggle('hf-option-card--active', !isSelected);
    }

    const oneTimeRadioWrap = oneTimeCard?.querySelector('.hf-radio');
    if (oneTimeRadioWrap) {
      oneTimeRadioWrap.classList.toggle('hf-radio--checked', !isSelected);
    }

    if (oneTimeRadio) {
      oneTimeRadio.checked = !isSelected;
    }

    if (subscriptionCard) {
      subscriptionCard.classList.toggle('hf-plan-selected', isSelected);
    }

    if (subscriptionOption) {
      subscriptionOption.checked = isSelected;
    }

    if (subscriptionRadio) {
      subscriptionRadio.classList.toggle('hf-radio-checked', isSelected);
    }

    if (subscriptionRadioIcon) {
      subscriptionRadioIcon.style.display = isSelected ? '' : 'none';
    }
  }

  function updatePlanButtonState(activeButton) {
    planButtons.forEach((btn) => {
      const isActive = btn === activeButton;
      btn.classList.toggle('hf-flavor-selected', isActive);

      const title = btn.querySelector('.fw-bold');
      const meta = btn.querySelector('[data-plan-meta]');
      const label = btn.getAttribute('data-plan-label') || '';

      if (title) {
        title.classList.toggle('hf-text-blue', isActive);
        title.classList.toggle('text-dark', !isActive);
      }

      if (meta) {
        meta.classList.toggle('hf-text-blue', isActive);
        meta.classList.toggle('fw-semibold', isActive);
        meta.classList.toggle('text-muted', !isActive);
        meta.textContent = isActive ? 'Selected' : label;
      }
    });

    const percent = activeButton?.getAttribute('data-plan-discount-percent') || '';

    if (subscriptionPercentEl) {
      subscriptionPercentEl.textContent = percent ? `${percent}%` : '';
    }

    if (summarySubscriptionPercent) {
      summarySubscriptionPercent.textContent = percent ? `${percent}%` : '';
    }
  }

  function updateBasePricing(variant) {
    if (!variant) return;

    if (mainPriceEl) {
      mainPriceEl.textContent = formatMoney(variant.price);
    }

    if (onetimePriceEl) {
      onetimePriceEl.textContent = formatMoney(variant.price);
    }
  }

  function setSellingPlanValue(planId) {
    if (!sellingPlanInput) {
      return;
    }

    if (planId) {
      sellingPlanInput.disabled = false;
      sellingPlanInput.value = String(planId);
    } else {
      sellingPlanInput.value = '';
      sellingPlanInput.disabled = true;
    }
  }

  function updateSubscriptionPricing() {
    const variant = getCurrentVariant();
    const planId = getSelectedPlanId();

    updateBasePricing(variant);

    if (!variant || !planId) {
      if (summarySubscriptionWrap) summarySubscriptionWrap.style.display = 'none';
      if (subscriptionPriceEl) subscriptionPriceEl.textContent = '';
      if (subscriptionCompareEl) subscriptionCompareEl.style.display = 'none';
      if (subscriptionBadgeEl) subscriptionBadgeEl.style.display = 'none';
      return;
    }

    const allocation = getAllocationForVariant(variant, planId);

    if (!allocation) {
      if (summarySubscriptionWrap) summarySubscriptionWrap.style.display = 'none';
      if (subscriptionPriceEl) subscriptionPriceEl.textContent = '';
      if (subscriptionCompareEl) subscriptionCompareEl.style.display = 'none';
      if (subscriptionBadgeEl) subscriptionBadgeEl.style.display = 'none';
      return;
    }

    const subPrice = allocation.price || 0;
    const compareAt = allocation.compare_at_price || variant.price || 0;
    const savings = compareAt > subPrice ? compareAt - subPrice : 0;

    const planPercent = getActivePlanPercent();
    const fallbackPercent = compareAt > subPrice ? Math.round((savings * 100) / compareAt) : 0;
    const finalPercent = planPercent ? `${planPercent}%` : (fallbackPercent > 0 ? `${fallbackPercent}%` : '');

    if (subscriptionPriceEl) {
      subscriptionPriceEl.textContent = formatMoney(subPrice);
    }

    if (summarySubscriptionPrice) {
      summarySubscriptionPrice.textContent = formatMoney(subPrice);
    }

    if (summarySubscriptionWrap) {
      summarySubscriptionWrap.style.display = '';
    }

    if (subscriptionCompareEl) {
      if (compareAt > subPrice) {
        subscriptionCompareEl.textContent = formatMoney(compareAt);
        subscriptionCompareEl.style.display = '';
      } else {
        subscriptionCompareEl.style.display = 'none';
      }
    }

    if (subscriptionBadgeEl && subscriptionSavingsEl) {
      if (savings > 0) {
        subscriptionSavingsEl.textContent = formatMoney(savings);
        subscriptionBadgeEl.style.display = '';
      } else {
        subscriptionBadgeEl.style.display = 'none';
      }
    }

    if (subscriptionPercentEl) {
      subscriptionPercentEl.textContent = finalPercent;
    }

    if (summarySubscriptionPercent) {
      summarySubscriptionPercent.textContent = finalPercent;
    }
  }

  if (oneTimeCard) {
    oneTimeCard.addEventListener('click', function () {
      setSubscriptionSelectedState(false);
      setSellingPlanValue(null);
      updateSubscriptionPricing();
    });
  }

  if (subscriptionCard) {
    subscriptionCard.addEventListener('click', function (e) {
      if (e.target.closest('[data-selling-plan-id]')) return;
      if (e.target.closest('[data-frequency-select]')) return;

      if (!frequencySelect) {
        let activeButton = getSelectedPlanButton();
        if (!activeButton && planButtons[0]) {
          activeButton = planButtons[0];
          updatePlanButtonState(activeButton);
        }
      }

      setSubscriptionSelectedState(true);
      setSellingPlanValue(getActivePlanId());
      updateSubscriptionPricing();
    });
  }

  planButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const selectedId = this.getAttribute('data-selling-plan-id');

      updatePlanButtonState(this);
      setSubscriptionSelectedState(true);
      setSellingPlanValue(selectedId);
      updateSubscriptionPricing();
    });
  });

  if (frequencySelect) {
    frequencySelect.addEventListener('change', function () {
      setSubscriptionSelectedState(true);
      setSellingPlanValue(getActivePlanId());
      syncSubscribePercentLabel();
      updateSubscriptionPricing();
    });
  }

  form.addEventListener('variant:change', function () {
    updateSubscriptionPricing();
  });

  if (frequencySelect) {
    syncSubscribePercentLabel();
  } else {
    const initiallySelectedPlan =
      form.querySelector('[data-selling-plan-id].hf-flavor-selected') || planButtons[0];

    if (initiallySelectedPlan) {
      updatePlanButtonState(initiallySelectedPlan);
    }
  }

  // Default to Subscribe & Save when the product has a plan to select,
  // falling back to One-Time for products without subscriptions.
  const defaultPlanId = subscriptionCard ? getActivePlanId() : null;

  setSubscriptionSelectedState(Boolean(defaultPlanId));
  setSellingPlanValue(defaultPlanId);
  updateSubscriptionPricing();

  form.addEventListener('submit', function () {
    const subscriptionIsSelected = subscriptionCard?.classList.contains('hf-plan-selected');

    if (subscriptionIsSelected) {
      setSellingPlanValue(getActivePlanId());
    } else {
      setSellingPlanValue(null);
    }
  });
});